/**
 * @module login 
 *  Apis must need auth details to trigger url - AuthApi
 */

 import store from '@/store/store';
 import Env from '@/env';
 import NormalApis from '@/Components/Controllers/NormalApis';
 
 
 export default {
     /**
      * Fetch business profile loyality
      */
    fetchBusinessLoyality(business_id) {
      const url = `${Env.businessLoyality.url}/api/v1/apps/business/${business_id}/programs?branding=true&program_token=true&referral_actions=true&settings=true`;
      return NormalApis.getApi(url)
      .then(async (res) => {
        await store.dispatch('businessprofile/setBusinessLoyality', res.data);
        return res;
      })
      .catch(err => {
        store.dispatch('businessprofile/setBusinessLoyality', {});
        store.dispatch('userloyalitysubscription/setUserLoyalityObj', {});
        return err;
      });
    },
    
    /**
     * Fetch faqs
     */
    fetchBusinessLoyalityFaqs(api_token) {
      const url = `${Env.businessLoyality.url}/api/v1/apps/faqs`;
      return NormalApis.getApi(url, {
        'api-token': api_token
      })
      .then(res => res)
      .catch(err => err);
    },
    /**
     * Fetch faqs default
     */
    fetchBusinessLoyalityFaqsDefault(api_token) {
      const url = `${Env.businessLoyality.url}/api/v1/apps/faqs/default`;
      return NormalApis.getApi(url, {
        'api-token': api_token
      })
      .then(res => res)
      .catch(err => err);
    }
    
 }